import React from "react";

export const Skills = ({
  technicalLabel,
  softLabel,
  technicalSkills,
  softSkills,
}) => {
  return (
    <>
      <section className="technical-skills section card" id="skills">
        <h2 className="section-title">{technicalLabel}</h2>
        <ul className="skills-list">
          {technicalSkills.map((skill) => <Skill key={skill} skill={skill} />)}
        </ul>
      </section>
      <section className="soft-skills section card">
        <h2 className="section-title">{softLabel}</h2>
        <ul className="skills-list">
          {softSkills.map((skill) => <Skill key={skill} skill={skill} />)}
        </ul>
      </section>
    </>
  );
};

const Skill = ({ skill }) => {
  const [rawLabel, ...rest] = skill.split(":");
  const details = rest.join(":").trim();
  const label = rest.length > 0 ? rawLabel.trim() : "";

  return (
    <li className="skills-chip">
      {label ? <span className="skills-chip-label">{label}</span> : null}
      <span className="skills-chip-text">{label ? details : skill}</span>
    </li>
  );
};